import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserTimelines } from '@wilson/interfaces';
import { LocationIdToLocationPipe } from '@wilson/locations';
import { PipesModule } from '@wilson/pipes';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-home-location-value',
  imports: [
    CommonModule,
    NzTooltipModule,
    TranslateModule,
    PipesModule,
    LocationIdToLocationPipe,
  ],
  templateUrl: './home-location-value.component.html',
  styleUrls: ['./home-location-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeLocationValueComponent {
  @Input() user!: UserTimelines;
}
